import { QuestionVariety } from "./Definition";
import { SingleValueQuestion } from "./SingleValueQuestion";

export default class MultilineTextQuestion extends SingleValueQuestion {
  get type(): QuestionVariety {
    return "text_multi";
  }
}
